import { useRegisterSW } from "virtual:pwa-register/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const logPrefix = "SERVICE WORKER:";
export function PWABadge() {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_, r) {
      console.debug("onRegisteredSW called", r);
    },
  });

  useEffect(() => {
    console.debug(`${logPrefix} Need refresh is ${needRefresh}`);
    if (needRefresh) {
      console.info(
        `${logPrefix} Need refresh is true --> Showing dialog to reload`,
      );
      alert(t("common.pwaUpdateAlert"));
      updateServiceWorker(true);
    }
  }, [needRefresh, updateServiceWorker, t]);

  return <></>;
}
